import { responsiveFontSizes, ThemeOptions } from "@mui/material";
import { grey } from '@mui/material/colors';
import { OnlinePatientManagement } from '@ngt/opms';

import * as Dtos from '../api/dtos';
import { AppSettings } from '../AppSettings';

import colorLogoNew from '@/assets/img/logo-h-c-new.png';
import whiteLogoNew from '@/assets/img/logo-h-w-new.png';

import { BctApiExtension } from '@ngt/opms-bctapi';

const createOnlinePatientManagement = (
    user?: Dtos.GetUserResponse, 

) => {
    const publicRoute = global.location.href.includes(AppSettings.consentParticipantUrl)

    if (!user && !publicRoute) {
        if (global.location.search) {
            global.location.href = '/auth/openiddict' + global.location.search;
            return;
        } else {
            global.location.href = '/auth/openiddict';
            return; 
        }
    }

    
    const onlinePatientManagement = new OnlinePatientManagement({
        trialOptions: {
            organisationLogoLight: colorLogoNew,
            organisationLogoDark: whiteLogoNew,
            organisationName: "Breast Cancer Trials",
            trialName: user ? "Prospect-AI" : '',
            protocolId: user ? "BCT" : '',
           //homePageUrl: AppSettings.trialPortalUrl ?? 'https://trialportal.breastcancertrials.org.au/'
        },
        serviceStackClient: {
            baseUrl: AppSettings.client.baseUrl,
            basePath: AppSettings.client.basePath
        },
        dtos: Dtos,
        fileUploadOptions: {
            allowRedaction: true,
            defaultRedactable: true,
            redactUrl: AppSettings.redactUrl
        },
        themeOptions: {
            overrideChosenTheme: AppSettings.palette.overrideTheme,
            beforeThemeCreated: (themeOptions, chosenTheme) => {
                let newOptions: ThemeOptions = {
                    ...themeOptions,
                    palette: {
                        ...themeOptions.palette,
                        primary: {
                            main: chosenTheme === 'dark' ? AppSettings.palette.primaryDark : AppSettings.palette.primaryLight
                        },
                        secondary: {
                            main: chosenTheme === 'dark' ? AppSettings.palette.secondaryDark : AppSettings.palette.secondaryLight 
                        },
                        error: {
                            main: chosenTheme === 'dark' ? AppSettings.palette.errorDark : AppSettings.palette.errorLight, 
                            // dark: AppSettings.palette.errorDark,
                        }
                    },
                    typography: (palette) => ({
                        h1: {
                            fontSize: '2rem',
                            color: chosenTheme === 'dark' ? palette.secondary.light : palette.secondary.main,
                        },
                        h2: {
                            fontSize: '1.5rem',
                            color: chosenTheme === 'dark' ? palette.primary.light : palette.primary.main,
                            fontWeight: '400' 
                        },
                        h3: {
                            fontSize: '1.25rem',
                            color: chosenTheme === 'dark' ? palette.secondary.light : palette.secondary.main,
                            fontWeight: '400' 
                        },
                        h4: {
                            fontSize: '1.20rem',
                            color: chosenTheme === 'dark' ? palette.primary.light : palette.primary.main,
                            fontWeight: '400'
                        },
                        h5: {
                            fontSize: '1.15rem',
                            color: chosenTheme === 'dark' ? palette.secondary.light : palette.secondary.main,
                            fontWeight: '400'
                        },
                        h6: {
                            fontSize: '1.10rem',
                            color: chosenTheme === 'dark' ? palette.primary.light : palette.primary.main,
                            fontWeight: '400'
                        }
                    })
                };

                if (chosenTheme !== 'dark') {
                    if (!newOptions.palette) {
                        newOptions.palette = {}
                    }
            
                    newOptions.palette.background = {
                        default: grey[200]
                    }
                }

                return newOptions;
            },
            afterThemeCreated: (theme: any) => {
                return responsiveFontSizes(theme);
            }
        },

        initialAuthentication: user,
 
        disableAuthentication: !user && publicRoute,
        extensions: [
            new BctApiExtension({}),
        ]
    });
    
    onlinePatientManagement.serviceStackClient.exceptionFilter = (res: Response, _error: any) => {
        if (res.status === 401 && !publicRoute) {
            global.location.href = `/auth/openiddict?redirect=${encodeURIComponent(global.location.pathname + global.location.search)}`;
        }
    };

    return onlinePatientManagement;
}

export default createOnlinePatientManagement;